<template lang="html">
    <report-section
        :id="id"
        title=""
        class="is-hidden-touch"
    >
        <div v-if="reportData.allocations.length !== 0">
            <pdf-allocations-wrapper
                v-for="(allocationType, index) in allocationTypes"
                :key="index"
                :intro-data="{
                    totalAllocationVolume,
                    licenceCount,
                    licencePluralization,
                }"
                :licences="reportData.allocations"
                :selected-type="allocationType"
                :index="index"
            />
        </div>

        <h4
            v-else
            class="title is-4"
        >
            No Allocations for selected watershed.
        </h4>
    </report-section>
</template>

<script>
import sectionMixin from '@foundryspatial/report-section/mixin';

import PdfAllocationsWrapper from '@/components/PDFAllocationsWrapper';

export default {
    name: 'AllocationsTableSection',

    components: {
        PdfAllocationsWrapper,
    },

    mixins: [
        sectionMixin,
    ],

    data: () => ({
        // declared statically so order will always be the same across reports
        allocationTypes: [
            'sw-lic',
            'gw-lic',
            'sw-stu',
            'gw-stu',
            'sw-app',
            'gw-app',
        ],
    }),

    computed: {
        totalAllocationVolume() {
            return this.reportData.overview.annualSurfaceWaterAllocation
                + this.reportData.overview.annualGroundwaterAllocation;
        },
        licenceCount() {
            const uniqueLicenceNumbers = new Set(this.reportData.allocations.map(allocation => allocation.licence_no));
            return uniqueLicenceNumbers.size;
        },
        licencePluralization() {
            if (this.reportData.allocations.length === 1) {
                return 'Licence';
            }
            return 'Licences';
        },
    },
};
</script>

<style lang="scss">
</style>
